import { ErrorMessage } from "formik";
import React from "react";

import { TQuestionOption } from "../../types";
import QuestionCopy from "./QuestionCopy";
import QuestionWrapper from "./QuestionWrapper";
import Checkbox from "./Checkbox";

type TQuesetionCheckboxGroupProps = {
  name: string;
  label?: string;
  note?: string;
  options: TQuestionOption[];
  error?: boolean;
};

const QuestionCheckboxGroup: React.FC<TQuesetionCheckboxGroupProps> = ({
  name,
  label,
  note,
  options,
  error,
}) => (
  <QuestionWrapper>
    <QuestionCopy name={name} label={label} note={note} />
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {options.map((option) => (
        <Checkbox error={error} key={option.value} name={name} option={option} />
      ))}
    </div>
    <ErrorMessage name={name}>
      {(msg) => <p style={{ fontSize: "14px", color: "#D82727" }}>{msg}</p>}
    </ErrorMessage>
  </QuestionWrapper>
);

export default QuestionCheckboxGroup;
